@if (isLoading) {
  @if (size === 'sm') {
    <div class="flex items-center gap-2">
      <div class="skeleton h-8 w-8 shrink-0 rounded-full"></div>
      <div class="skeleton hidden h-4 w-24 rounded sm:block"></div>
    </div>
  } @else {
    <div class="flex items-center gap-3">
      <div class="skeleton h-10 w-10 shrink-0 rounded-full"></div>
      <div class="flex flex-col gap-1.5">
        <div class="skeleton h-4 w-28 rounded"></div>
        <div class="skeleton h-3 w-20 rounded"></div>
      </div>
    </div>
  }
} @else if (user) {
  @if (size === 'sm') {
    <div class="flex items-center gap-3">
      <ui-avatar
        [src]="user?.profile_image"
        [name]="displayName"
        [alt]="displayName"
        size="sm"
      ></ui-avatar>
      <span
        class="hidden max-w-[7.5rem] truncate text-sm font-medium sm:inline"
        [class.text-white]="tone === 'overlay'"
      >
        {{ displayName | titlecase }}
      </span>
    </div>
  } @else {
    <div class="flex items-center gap-3">
      <ui-avatar
        [src]="user?.profile_image"
        [name]="displayName"
        [alt]="displayName"
        size="md"
      ></ui-avatar>
      <div class="min-w-0 flex-1">
        <p class="truncate font-semibold">{{ displayName | titlecase }}</p>
        @if (roleLabel) {
          <p class="truncate text-xs text-base-content/60">{{ roleLabel }}</p>
        }
      </div>
    </div>
  }
}
